import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import modules from './modules';
import allSpaces from './modules/allSpaces';
import editingStep from './modules/editingStep';
import myExperiences from './modules/myExperiences';
import scene from './modules/scene';
import space from './modules/space';
import auth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
	strict: true,
	plugins: [createPersistedState()],
	modules: {
		allSpaces,
		editingStep,
		myExperiences,
		scene,
		space,
		auth
	},
});
